import React from 'react'

import { useNavigate, useParams } from 'react-router-dom'

import { InlineMenuNoButtonProps } from '../../types'
import { Button } from '../buttons'

import { NavbarContainer, NavbarLinkContainer } from './styles'

const InlineMenuNoButton = ({
  parent,
  menu,
  editing,
  type,
  isTopMenu = false,
}: InlineMenuNoButtonProps) => {
  const navigate = useNavigate()
  const { part } = useParams<{ part: string }>()
  const activeItem = type || part

  const _menu = Object.values(menu) as { label: string; description: string }[]

  const handleClick: (item: string) => void = (item: string) => {
    if (!editing) {
      const param = item
      const url = parent ? `/${parent}/${param}` : `/${param}`
      navigate(url)
    }
  }

  return (
    <NavbarContainer>
      <NavbarLinkContainer className={isTopMenu ? 'top-menu' : ''}>
        {_menu.map((item, i) => {
          return (
            <Button
              className={`underline ${activeItem === item.label ? 'active' : undefined}`}
              onClick={() => handleClick(item.label)}
              disabled={editing}
              key={i}
              label={item.description}
            />
          )
        })}
      </NavbarLinkContainer>
    </NavbarContainer>
  )
}

export default InlineMenuNoButton
